import { inject, NgModule } from '@angular/core';
import { DefaultValueAccessor } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule()
export class AppModule {
  private matIconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  constructor() {
    this.matIconRegistry
      .addSvgIcon(
        'logo',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/logo.svg')
      )
      .addSvgIcon(
        'microphone',
        this.sanitizer.bypassSecurityTrustResourceUrl(
          'assets/icons/microphone.svg'
        )
      )
      .addSvgIcon(
        'artist',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/artist.svg')
      );
    DefaultValueAccessor.prototype.registerOnChange = function (
      fn: (_: string | null) => void
    ): void {
      this.onChange = (value: string | null) => {
        fn(value === '' ? null : value);
      };
    };
  }
}
